// Lib
import React from 'react';
import { useDispatch } from 'react-redux';

// Actions
import { fetchNotifications } from '../../../../../../notifications/notificationActions';

// Components
import PopupErrorMessage from '../../../../../../components/popupPanel/PopupErrorMessage';

const NotificationsErrorMessage = () => {
    const dispatch = useDispatch();
    const dispatchFetchNotifications = (args) => dispatch(fetchNotifications(args));

    return (
        <PopupErrorMessage
            description="There was a problem loading your notifications"
            onCtaClick={dispatchFetchNotifications}
        />
    );
};

NotificationsErrorMessage.propTypes = {};

export default NotificationsErrorMessage;
